export const frAudits = {
    'navbar.audits': 'Audits',
    'audits.name': 'Audit',
    'audits.themes.name': 'Theme', //* TO TRAD
    'audits.autocheck.name': 'Auto-check',

    'audits.status.InProgress': 'En cours',
    'audits.status.GroupLeaderSigned': 'À signer',
    'audits.status.Done': 'Terminé',
    'audits.status.Cancelled': 'Annulé',
    //! à trad dans les autres langues IT
    'audits.status.Read': 'Vu, à signer',
    'audits.status.ToDo': 'A faire',

    //* AUDITS FILTERS
    'audits.filter.creator': 'Créé par',
    'audits.filter.themes': 'Thèmes',
    'audits.filter.from_date': 'Du',
    'audits.filter.to_date': 'Au',
    'audits.filter.label.themes': 'Thèmes : {value}',

    'audits.filter.created_by': 'Créé par',
    'audits.filter.created_by.me': 'Moi',
    'audits.filter.created_by.all': 'Tout le monde',
    'audits.filter.label.created_by.me': 'Crée par : Moi',

    'audits.type.Manual': 'Audit', //* TO TRAD
    'audits.type.AutoCheck': 'Auto-check',
    'audits.filter.label.type': 'Type : {type}',

    //* AUDITS LIST
    'audits.list.header.theme.title': "THEMES D'AUDIT",
    'audits.list.header.history.title': 'HISTORIQUE AUDITS',
    'audits.list.header.autochecks.title': 'AUTO-CHECKS',
    'audits.header.analysis.title': 'ANALYSE AUDITS',
    'audits.header.tags.title': 'TAGS',

    'audits.tags.title': 'Tags',
    'audits.tags.list.pageTitle': 'Tags',
    'audits.tags.list.actions.addAuditTag': 'Créer un tag',

    'audits.themes.title': 'Thèmes',
    'audits.themes.list.pageTitle': 'Thèmes',
    'audits.themes.list.actions.addAuditTheme': 'Créer un thème',

    'audits.themes.list.table.header.questionCount': 'Nb de questions',
    'audits.themes.list.table.emptyLabel': "Il n'y a pas de thème pour le moment",

    //* AUDITS INFORMATIONS
    'audits.themes.info.title': 'Titre du thème *',
    'audits.themes.info.ref': 'Référence du thème',
    'audits.themes.info.hint.description': 'Saisissez ici la description du thème',
    'audits.themes.info.owner.select.title': 'Sélectionnez le propriètre du thème',
    'audits.themes.info.tags': 'Sélectionner des tags que vous voulez ajouter à votre thème :',
    'commons.info.icons.select.title': "Choix de l'icône *",

    'audits.themes.info.ignoreSignature.title': 'Ignorer la signature',
    'audits.themes.info.ignoreSignature': 'Permettre aux utilisateurs d’ignorer la deuxième signature',


    //* AUDITS >> CREATE AND DETAILS
    'audits.themes.create.pageTitle': 'Création thème',
    'audits.themes.details.pageTitle': 'Détails thème',
    'audits.themes.details.actions.previous': 'Thèmes',
    'audits.themes.details.remove.dialog.title': 'Suppression du thème',
    'audits.themes.details.remove.dialog.content': 'Êtes-vous sûr de vouloir supprimer ce thème ?',

    //* AUDITS QUESTIONS
    'audits.themes.questions.addQuestion': 'Ajouter une question',
    'audits.themes.questions.title': 'Question {index}',
    'audits.themes.questions.max_points': 'Points',
    'audits.themes.questions.ref': 'Réference',
    'audits.themes.questions.details': 'Détail',
    'audits.themes.questions.mandatory': 'Obligatoire',

    'audits.themes.questions.remove.dialog.title': 'Supprimer cette question',
    'audits.themes.questions.remove.dialog.content':
        'Êtes-vous sûr de vouloir supprimer cette question ?',

    'audits.themes.questions.details.dialog.title': 'Details',

    'audits.themes.questions.import.success': 'Bravo! questions importés avec succès',

    //* AUDITS DETAILS //TABS //RESULTS -> TO REVIEW

    'audits.themes.results.filters.label.shop': 'Centres',
    'audits.themes.results.filters.label.from_date': 'Du',
    'audits.themes.results.filters.label.to_date': 'Au',

    'audits.themes.results.tableHeader.shop': 'Centres',
    'audits.themes.results.tableHeader.creator': 'Créé par',
    'audits.themes.results.tableHeader.last_visite': 'Date de la visite',
    'audits.themes.results.tableHeader.score': 'Score',
    'audits.themes.results.tableHeader.status': 'Statut',
    'audits.themes.results.tableHeader.pdf': 'PDF',

    'audits.themes.results.scoreFormat': '{score}%',
    'audits.themes.results.seePdf': 'PDF',

    'audits.themes.results.emptyLabel': 'Aucun résultat pour le moment.',

    'audits.themes.results.filter.label.creator': 'Créé par : {value}',

    //* NOT AUDITED SHOPS
    'audits.themes.results.shops_not_audited':
        'Sur cette période, ces centres n’ont pas été audité sur ce thème :',
    'audits.themes.results.shop_not_audited': '- {name}',

    //* AUDITS HISTORY

    'audits.history.title': 'Audits',
    'audits.history.list.pageTitle': 'Audits',

    'audits.history.list.table.header.info': 'Titre',
    'audits.history.list.table.header.shops': 'Centres',
    'audits.history.list.table.header.date': 'Date',
    'audits.history.list.table.header.creator': 'Créé par',
    'audits.history.list.table.header.themes': 'Thèmes',
    'audits.history.list.table.header.status': 'Statut', //! à trad dans les autres langues ES, IT, NL
    'audits.history.list.table.header.actions': 'Actions', //! à trad dans les autres langues
    'audits.history.list.table.header.pdf': 'PDF',

    'audits.history.list.table.emptyLabel': "Il n'y a pas d'audit pour le moment",

    'audits.history.list.remaining_theme_icons': '+{count}',
    'audits.history.list.seePdf': 'PDF',

    'audits.reopen.title': "Modifier l'audit",
    'audits.reopen.content': "Êtes-vous sûr de vouloir modifier l'audit ?",

    //* AUDITS PERMISSIONS
    'backofficeUsers.create.tabs.permissions.sectionTabs.audits': 'Audits',
    'backofficeUsers.permissions.audits.contentcreate': 'Création de thème',
	'backofficeUsers.permissions.audits.managethemetag': 'Création de tags pour les audits',

    //* AUDITS ERRORS
    'toast.apiErrors.ICON_MUST_BE_DEFINED': "L'image doit être définie",

    'toast.apiErrors.THEME_MUST_HAVE_ONE_QUESTION_AT_LEAST':
        'Le thème doit comporter au moins une question',

    //* AUDIT THEME AUDIENCES DEFINITION
    'audits.audiences.def.title':
        'Ce thème peut être utilisé par les responsables des centres uniquement ou par certains rôles des collaborateurs.',
    'audits.audiences.def.subtitle': "Sélectionnez votre type d'audience :",

    'audits.audiences.def.type.shop.title': 'Seul un responsable peut utiliser le thème',
    'audits.audiences.def.type.shop.subtitle': '(Seul un responsable peut répondre)',
    'audits.audiences.def.type.collaborator.title':
        'Tous les rôles des collaborateurs sélectionnés peuvent utiliser le thème',
    'audits.audiences.def.type.collaborator.subtitle':
        '(Tous les rôles des collaborateurs sélectionnés peuvent répondre au sondage)',

    //* AUTO-CHECKS

    'audits.autochecks.title': 'Auto-check',
    'audits.autochecks.list.pageTitle': 'Auto-check',
    'audits.autochecks.list.actions.addAuditTheme': 'Créer un auto-check',

    'audits.autochecks.list.table.header.recurrenceType': 'Récurrence',
    'audits.autochecks.list.table.emptyLabel': "Il n'y a pas d'auto-check pour le moment",

    'audits.autochecks.reccurenceType.None': 'Pas de récurrence',
    'audits.autochecks.reccurenceType.Weekly': 'Hebdomadaire',
    'audits.autochecks.reccurenceType.Monthly': 'Mensuelle',

    //* AUDIT AUTOCHECK INFORMATIONS
    'audits.autochecks.info.title': "Titre de l'auto-check *",
    'audits.autochecks.info.ref': "Référence de l'auto-check",

    //* AUDITS AUTOCHECK>> CREATE AND DETAILS
    'audits.autochecks.create.pageTitle': 'Création auto-check',
    'audits.autochecks.details.pageTitle': 'Détails auto-check',
    'audits.autochecks.details.actions.previous': 'Auto-check',
    'audits.autochecks.remove.dialog.title': "Suppression de l'auto-check",
    'audits.autochecks.remove.dialog.content':
        'Êtes-vous sûr de vouloir supprimer cet auto-check ?',

    //* AUDITS AUTOCHECK INFORMATIONS
    'audits.autochecks.reccurence.title': 'Récurrence',
    'audits.autochecks.reccurence.weekOfMonth': 'Choix de la semaine',
    'audits.autochecks.reccurence.dayOfWeek': 'Choix du jour de la semaine',
    'audits.autochecks.reccurence.creationTime': 'Heure de création',
    'audits.autochecks.reccurence.expiration': 'Nombre de jours avant échéance',
    'audits.autochecks.reccurence.expiration.subtitle': 'Mini {min}, maxi {max}',
    'audits.autochecks.reccurence.label.endDate': 'Date de fin',
    'audits.autochecks.reccurence.endDate': 'Sélectionnez une date de fin',

    'audits.autochecks.themes.title': 'Choix des thèmes',
    'audits.autochecks.themes.empty': "Il n'y a pas de thème pour le moment",
    'audits.autochecks.themes.add': 'Ajouter un nouveau thème',

    'audits.autochecks.audience.def.title':
        'Sélectionnez les rôles des collaborateurs autorisées à réaliser cet auto-check.',

    'audits.autochecks.notifs.enableOnRecurrence': 'Envoyer une notification à la récurrence',
    'audits.autochecks.notifs.manualInfo':
        "Relancer les utilisateurs qui n'ont pas encore validé leur auto-check",

    'audits.autochecks.results.tableHeader.shop': 'Centres',
    'audits.autochecks.results.tableHeader.validated_at': 'Validé le',
    'audits.autochecks.results.tableHeader.validator': 'Validé par',
    'audits.autochecks.results.tableHeader.score': 'Score',
    'audits.autochecks.results.tableHeader.status': 'Statut',
    'audits.autochecks.results.tableHeader.pdf': 'PDF',

    'audits.autochecks.results.created_at': 'Auto-check créé le : {date}',
    'audits.autochecks.results.created_at.canceled': 'Auto-check créé le : {date} (annulé)',

    'audits.autochecks.results.title.part1': 'Réponses :',
    'audits.autochecks.results.title.part2':
        '{count} {count, plural, =0 {centres} one {centre} other {centres}} / {maximum}',

    'audits.autochecks.results.occurences.empty': "Il n'y a pas d'occurence pour le moment",

    //* AUDITS ANALYSIS
    'audits.analysis.score.title': 'Score moyen',
    'audits.analysis.score.filter.apply': 'Appliquer',
    'audits.analysis.score.filter.cancel': 'Annuler',
    'audits.analysis.score.filter.date.title': 'choix de la durée',
    'audits.analysis.score.filter.date.this_week': 'Cette semaine',
    'audits.analysis.score.filter.date.this_month': 'Ce mois',
    'audits.analysis.score.filter.date.this_year': 'Cette année',
    'audits.analysis.score.filter.date.week': 'Une semaine',
    'audits.analysis.score.filter.date.month': 'Un mois',
    'audits.analysis.score.filter.date.year': 'Une année',
    'audits.analysis.score.filter.date.custom': 'Personnalisées',
    'audits.analysis.score.filter.date.empty': 'Dates : personalisées',
    'audits.analysis.score.filter.date.placeholder': 'Dates : {dates}',
    'audits.analysis.score.filter.theme.empty': 'Thèmes : sélectionner',
    'audits.analysis.score.filter.theme.placeholder': 'Thèmes : {number} thème',
    'audits.analysis.score.filter.theme.placeholder.plural': 'Thèmes : {number} thèmes',
    'audits.analysis.score.filter.theme.placeholder.all': 'Thèmes : tous',
    'audits.analysis.score.filter.theme.title': 'Thèmes',
    'audits.analysis.score.filter.audience.placeholder.empty': 'Audience: sélectionner',
    'audits.analysis.score.filter.audience.placeholder': 'Audience : {number} centre',
    'audits.analysis.score.filter.audience.placeholder.plural': 'Audience : {number} centres',
    'audits.analysis.score.filter.audience.placeholder.all': 'Audience : tous',
    'audits.analysis.score.switch.region.title': 'Par région',
    'audits.analysis.score.switch.question.title': 'Par thème',

    'audits.analysis.region.title': 'Comparatif régions',
    'audits.analysis.region.all.title': 'Toutes',
    'audits.analysis.question.title': 'Comparatif thèmes',
    'audits.analysis.question.all.title': 'Tous',
    'audits.analysis.region.table.header.title.region': 'Région',
    'audits.analysis.question.table.header.title.region': 'Thème',
    'audits.analysis.table.header.title.number': "Nbre d'audits",
    'audits.analysis.table.header.title.score': 'Score moyen',
    'audits.analysis.table.header.title.missing': '% non audités',
    'audits.analysis.region.chart.title': 'Région :',
    'audits.analysis.question.chart.title': 'Thème :',
    'audits.analysis.chart.conform': 'Score moyen',
    'audits.analysis.chart.na': 'N/A',
    'audits.analysis.chart.legend.high': '> 85%',
    'audits.analysis.chart.legend.middle': '60% - 85%',
    'audits.analysis.chart.legend.low': '< 60%',
    'audits.analysis.chart.legend.missing': 'Non audités',

    'audits.analysis.shop.title': 'Comparatif centres',
    'audits.analysis.shop.subtitle': 'Région :',
    'audits.analysis.shop.category.title': '{nb} Centres',
    'audits.analysis.shop.category.singular.title': '{nb} Centre',

    'audits.analysis.shop.category.title.high': '> 85%',
    'audits.analysis.shop.category.title.middle': '60%',
    'audits.analysis.shop.category.title.middle2': '- 85%',
    'audits.analysis.shop.category.title.low': '< 60%',
    'audits.analysis.shop.category.title.missing': 'Non audités ({nb} Centres)',
    'audits.analysis.shop.category.title.missing.singular': 'Non audités ({nb} Centre)',
    'audits.analysis.shop.category.tooltip.percentage': '{value}% score moyen',
    'audits.analysis.shop.category.tooltip.audits.number': '{value} audits',
    'audits.analysis.shop.category.tooltip.audits.singular.number': '{value} audit',

    'audits.analysis.region.theme.section.title': 'Détail des audits',
    'audits.analysis.region.question.subtitle': 'Centre :',
    'audits.analysis.region.question.table.header.question': 'Questions',
    'audits.analysis.region.question.table.header.nbaudits': "Nbre d'audits",
    'audits.analysis.region.question.table.header.score': 'Score',
    'audits.analysis.region.question.table.header.comments': 'Commentaires',
    'audits.analysis.region.question.table.header.pictures': 'Photos',
    'audits.analysis.region.question.table.body.see': 'Voir',

    'audits.analysis.theme.question.title': 'Liste des questions',
    'audits.analysis.theme.question.subtitle': 'Thème :',
    'audits.analysis.theme.question.table.header.question': 'Questions',
    'audits.analysis.theme.question.table.header.nbaudits': "Nbre d'audits",
    'audits.analysis.theme.question.table.header.score': 'Score',
    'audits.analysis.theme.question.table.header.missing': 'Non audités',
    'audits.analysis.theme.question.table.header.comments': 'Commentaires',
    'audits.analysis.theme.question.table.header.pictures': 'Photos',
    'audits.analysis.theme.question.table.body.title.current': '{title}',
    'audits.analysis.theme.question.table.body.title.old': '{title} - (Anciennes questions)',
    'audits.analysis.theme.question.table.body.see': 'Voir',

    'audits.analysis.theme.shop.title': 'Comparatif centres',
    'audits.analysis.theme.shop.subtitle': 'Question :',
    'audits.analysis.theme.shop.table.header.shop': 'Centre',
    'audits.analysis.theme.shop.table.header.nbaudits': "Nbre d'audits",
    'audits.analysis.theme.shop.table.header.score': 'Score',
    'audits.analysis.theme.shop.table.header.comments': 'Commentaires',
    'audits.analysis.theme.shop.table.header.pictures': 'Photos',
    'audits.analysis.theme.shop.table.body.see': 'Voir',

    'audits.analysis.comments.modal.title': 'Liste des commentaires',
    'audits.analysis.comments.modal.question': 'Question :',
    'audits.analysis.comments.modal.status': 'Statut: {status}',
    'audits.analysis.comments.modal.status.empty': 'sélectionner',
    'audits.analysis.comments.modal.status.all': 'Tous',
    'audits.analysis.comments.modal.status.yes': 'Oui',
    'audits.analysis.comments.modal.status.no': 'Non',
    'audits.analysis.comments.modal.status.na': 'N/A',
    'audits.analysis.comments.modal.paper.title': 'Statuts',
    'audits.analysis.comments.modal.table.date': 'Date',
    'audits.analysis.comments.modal.table.user': "Réalisateur de l'audit",
    'audits.analysis.comments.modal.table.shop': 'Centre',
    'audits.analysis.comments.modal.table.comment': 'Commentaires',
    'audits.analysis.comments.modal.region.shop': 'Centre :',
    'audits.analysis.comments.modal.theme.theme': 'Thème :',

    'audits.analysis.pictures.modal.title': 'Galerie photos',
    'audits.analysis.pictures.modal.question': 'Question :',
    'audits.analysis.pictures.modal.status': 'Statut: {status}',
    'audits.analysis.pictures.modal.status.empty': 'sélectionner',
    'audits.analysis.pictures.modal.status.all': 'Tous',
    'audits.analysis.pictures.modal.status.yes': 'Oui',
    'audits.analysis.pictures.modal.status.no': 'Non',
    'audits.analysis.pictures.modal.status.na': 'N/A',
    'audits.analysis.pictures.modal.paper.title': 'Statuts',
    'audits.analysis.pictures.modal.theme.theme': 'Thème :',
    'audits.analysis.pictures.modal.tooltip.author': 'Auteur :',
    'audits.analysis.pictures.modal.export': 'Export zip',

    //* AUDITS CONTENT
    'audits.details.actions.previous': 'Audits',
    'audits.details.info.title': "Titre de l'audit *",
    'audits.details.score.title': "Score",

    'audits.details.theme.title': "Choix de thèmes",
    'audits.details.addTheme.title': "Ajouter un nouveau thème",
    'audits.details.addTheme.select': "Choisissez un nouveau thème",


    'audits.details.info.shop': "Centre",
    'audits.details.signature.title': "Signature",
    'audits.details.globalComment.label': "Commentaire global",
    'audits.details.globalScore.title': "Note globale",
    'audits.details.action.sign': "Signer",
    'audits.details.sign.title': "Signer l'audit",
    'audits.details.sign.content': 'Enregistrez votre audit et rouvrez-le sur votre application mobile afin de le signer',

    'audits.details.questions.progress': 'Avancement : {min} / {max}',
    'audits.details.questions.score': 'Score : {score} %',
    'audits.details.questions.title': 'Question {index}. {title} {subtitle}',
    'audits.details.questions.subtitle': 'Points : {points}/{max}',
    'audits.details.questions.comment': 'Commentaire',

    'audits.themes.details.pictures.title': 'Photos {subtitle}',
    'audits.themes.details.pictures.subtitle': '{count} / {max} Max',
    'audits.themes.details.remove.picture.title': "Suppression de l'image",
    'audits.themes.details.remove.picture.content': 'Êtes-vous sûr de vouloir supprimer cette image ?',

};
